import React, { useContext } from 'react'
import { RootContext } from '../../context/rootContext'
import logoPetanjo from '../../assets/logo-petanjo.svg'
import * as S from './styles'

const Header = () => {
  const { globalState } = useContext(RootContext)
  const [state] = globalState

  const isVet = () => {
    const professional = state?.userData?.professional
    return professional && professional.role === 'VETERINARIAN'
  }

  return (
    <S.Container>
      <S.GroupLogo>
        <S.Logo src={logoPetanjo} alt="logo petanjo" />
      </S.GroupLogo>
      <S.Title>Marketplace Serviços</S.Title>
      {isVet() && <S.Badge>Beta</S.Badge>}
    </S.Container>
  )
}

export default Header
